'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import UINavList from './UINavList';

class UISideNav extends Component {
  render() {
    const _this$props = this.props,
          {
      className
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    return /*#__PURE__*/_jsx(UINavList, Object.assign({}, rest, {
      className: className,
      _rootComponent: UISideNav
    }));
  }

}

UISideNav.displayName = 'UISideNav';
UISideNav.propTypes = Object.assign({}, UINavList.propTypes, {
  divider: PropTypes.bool,
  headingText: PropTypes.node
});
UISideNav.defaultProps = Object.assign({}, UINavList.defaultProps, {
  divider: false,
  headingText: ''
});
export default UISideNav;